import { jsx as _jsx } from "react/jsx-runtime";
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { removeToastSelector, temporalToastSelector } from '@/state/config';
import { Toast } from './Toast';
import styles from './Toast.module.scss';
const SHOW_DURATION_MS = 3500;
export const ToastsWrapper = () => {
    const toasts = useRecoilValue(temporalToastSelector);
    const removeToast = useRecoilCallback(({ snapshot, set }) => (id) => {
        const loadable = snapshot.getLoadable(removeToastSelector(id));
        if (loadable.state === 'hasValue') {
            set(removeToastSelector(id), loadable.contents);
        }
    });
    return (_jsx("div", { className: styles.toastsWrapper, children: toasts.map((toast, index) => (_jsx(Toast, { toast: toast, onRemove: removeToast, timeToRemove: SHOW_DURATION_MS + index * 1000 }, toast.id))) }));
};
